import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDdavWW8gij7iKJGL7WdfTa1UJpdI-AI7c",
  authDomain: "randomthoughtoftheday-u.firebaseapp.com",
  projectId: "randomthoughtoftheday-u",
  storageBucket: "randomthoughtoftheday-u.appspot.com",
  messagingSenderId: "925352417811",
  appId: "1:925352417811:web:38010a371b6023bb623de6",
  measurementId: "G-D7MH0ER06F"
});

const db = firebaseApp.firestore();

export { db };
